// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"274":"94d19422","373":"ff9770ef","469":"a2dbd062","671":"22c027e6","835":"d83d5313"}[chunkId] + ".chunk.css";
};